import { Segment } from "../../CommonLandingMweb.types";
import { Button, ButtonContainer, ButtonWrapper, Container, Label, TagImg } from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";
import { TextNodeType } from "@tm/isomorphic-utils";

interface PlanTypeSelectorProps {
  segments?: Segment[];
  label?: TextNodeType;
  onSegmentSelect?: (segment: Segment) => void;
}

export const PlanTypeSelector = ({
  segments = [],
  label,
  onSegmentSelect,
}: PlanTypeSelectorProps) => {
  if (!segments.length) return null;

  return (
    <Container>
      <Label>
        <FormattedText value={label || "TYPE OF PLAN"} />
      </Label>
      <ButtonContainer>
        {segments.map((segment) => (
          <ButtonWrapper key={segment.id}>
            {segment.tagImg ? <TagImg src={segment.tagImg} alt="tag" /> : null}
            <Button
              $selected={Boolean(segment.isSelected)}
              onClick={() => onSegmentSelect?.(segment)}
            >
              {segment.name}
            </Button>
          </ButtonWrapper>
        ))}
      </ButtonContainer>
    </Container>
  );
};

